import { HttpClient } from '@angular/common/http';
import { Injectable, Signal, signal } from '@angular/core';
import { Entity } from '@core/models';
import { environment } from '@env/environment';
import { UserStatus } from '@shared/enums';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class EntityApiService extends BaseService<Entity> {
  protected statusFilter = signal<number[]>([UserStatus.ACTIVE]);

  constructor(http: HttpClient) {
    super(`${environment.baseUrl}/entities`, http);
  }

  /** Define los filtros */

  getStatusFilter(): Signal<number[] | null> {
    return this.statusFilter;
  }

  setStatusFilter(statusId: number[]): void {
    this.statusFilter.set(statusId);
  }

  /** FILTROS */

  protected override filterFunctionSearch(item: Entity, query: string): boolean {
    return (
      item.nit.toLowerCase().includes(query) ||
      item.acronym.toLowerCase().includes(query) ||
      item.code.toLowerCase().includes(query) ||
      item.notificationEmail.toLowerCase().includes(query) ||
      item.phone.toLowerCase().includes(query)
    );
  }

  protected override applyAdditionalFilters(items: Entity[]): Entity[] {
    let filtered = [...items];

    const filterValue = this.statusFilter();
    if (filterValue && filterValue.length) {
      filtered = filtered.filter((user) => filterValue.includes(user.statusId));
    }

    return filtered;
  }
}
